(()=>{
const init=()=>{
 const status=document.querySelector('.ek-builder-status');
 if(status&&!status.dataset.ready){
  status.dataset.ready='true';document.querySelector('.ekh-header')?.after(status);status.style.removeProperty('display');
  let timer;let poll;
  const ready=()=>{
   const roots=[...document.querySelectorAll('[data-brix-combo-root],.bxq-root')];
   const built=roots.some(root=>{const content=root.shadowRoot||root;return content.querySelectorAll('img').length>0&&content.querySelectorAll('button').length>1;})||!!document.querySelector('.bxq-card,.bxq-grid');
   if(built){status.hidden=true;observer.disconnect();clearTimeout(timer);clearInterval(poll);return true;}
   return false;
  };
  const observer=new MutationObserver(ready);observer.observe(document.body,{childList:true,subtree:true});poll=setInterval(ready,500);
  timer=setTimeout(()=>{if(!ready()){status.querySelector('[data-builder-message]').textContent=status.dataset.error||'Your choices are taking longer to load. Please try again.';status.querySelector('.ek-builder-spinner').hidden=true;status.querySelector('[data-builder-retry]').hidden=false;}},20000);
  status.querySelector('[data-builder-retry]').onclick=()=>location.reload();ready();
 }
 if(document.body.classList.contains('template-product')){
  const refresh=()=>{if(!window.jQuery)return;document.querySelectorAll('[data-image-gallery-main].slick-initialized').forEach(slider=>{try{window.jQuery(slider).slick('setPosition');}catch{}});};
  document.querySelectorAll('[data-main-image]').forEach(img=>{if(!img.complete)img.addEventListener('load',refresh,{once:true});});
  window.addEventListener('load',refresh,{once:true});window.addEventListener('resize',refresh,{passive:true});
  requestAnimationFrame(refresh);
  const nativeButton=document.querySelector('.productView .product-form__submit');
  if(nativeButton&&!document.querySelector('.ek-mobile-purchase')&&!document.querySelector('[data-ek-sticky-purchase]')){
   const wrap=document.createElement('div');wrap.className='ek-mobile-purchase';
   const button=document.createElement('button');button.type='button';wrap.append(button);document.body.append(wrap);
   const sync=()=>{
    const rect=nativeButton.getBoundingClientRect();
    wrap.hidden=innerWidth>767||(rect.top>=0&&rect.bottom<innerHeight-70);
    const prices=[...document.querySelectorAll('.productView-price .price-item--sale,.productView-price .price-item--regular')];
    const price=prices.find(n=>n.getClientRects().length&&getComputedStyle(n).visibility!=='hidden');
    button.textContent=nativeButton.textContent.trim()+(price?' · '+price.textContent.trim():'');
    button.disabled=nativeButton.disabled;
   };
   button.onclick=()=>{nativeButton.click();sync();};
   new MutationObserver(sync).observe(document.querySelector('.productView-details')||nativeButton.parentElement,{childList:true,subtree:true,attributes:true,attributeFilter:['disabled']});
   window.addEventListener('scroll',sync,{passive:true});window.addEventListener('resize',sync,{passive:true});sync();
  }
 }
};if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();document.addEventListener('shopify:section:load',init);
})();


(()=>{
if(!('IntersectionObserver' in window))return;
const selector='[data-brix-combo-root] button[data-combo-action="qs-more"]';
const attempts=new WeakMap();
const observed=new Set();
let queued=false;
const observer=new IntersectionObserver(entries=>{
for(const entry of entries){
if(!entry.isIntersecting)continue;
const button=entry.target,root=button.closest('[data-brix-combo-root]');
if(!root||button.disabled||button.getAttribute('aria-disabled')==='true')continue;
const key=root.querySelectorAll('article').length+':'+button.textContent.trim();
if(attempts.get(button)===key)continue;
attempts.set(button,key);
observer.unobserve(button);observed.delete(button);
button.click();
}
},{rootMargin:'0px 0px 320px 0px'});
const scan=()=>{
queued=false;
for(const button of observed){if(!button.isConnected){observer.unobserve(button);observed.delete(button);}}
document.querySelectorAll(selector).forEach(button=>{
const root=button.closest('[data-brix-combo-root]');
const key=root.querySelectorAll('article').length+':'+button.textContent.trim();
if(!observed.has(button)&&attempts.get(button)!==key&&!button.disabled&&button.getAttribute('aria-disabled')!=='true'){
observed.add(button);observer.observe(button);
}
});
};
const queue=()=>{if(!queued){queued=true;requestAnimationFrame(scan);}};
const start=()=>{
const main=document.querySelector('main');
if(!main)return;
new MutationObserver(queue).observe(main,{childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['disabled','aria-disabled']});
scan();
};
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
document.addEventListener('shopify:section:load',queue);
})();

(()=>{
if(!document.body.classList.contains('template-product'))return;
const main=document.querySelector('main');if(!main)return;
let queued=false;
const tidy=()=>{
queued=false;
main.querySelectorAll('ps-coupon-slider').forEach(slider=>{
const empty=slider.children.length===1&&slider.firstElementChild?.tagName==='P'&&slider.textContent.trim()==='No coupons configured.';
if(slider.classList.contains('ek-empty-coupon')!==empty)slider.classList.toggle('ek-empty-coupon',empty);
});
};
new MutationObserver(()=>{if(!queued){queued=true;requestAnimationFrame(tidy);}}).observe(main,{childList:true,subtree:true,characterData:true});
tidy();
})();

document.addEventListener('click',event=>{
const overlay=event.target;
if(!(overlay instanceof Element)||overlay.id!=='cc-overlay'||!overlay.classList.contains('active'))return;
const close=overlay.querySelector('#cc-drawer .cc-drawer-header button');
if(!close||close.disabled)return;
event.preventDefault();
close.click();
});
